// Firma tarafı belge dosyası işlemleri: yükle / "Belge yüklendi" + görüntüle + sil / yeni sürüm
import { DependencyRuleNote } from './docDependencies';
import { confirmDialog } from '../ConfirmHost';
import axios from 'axios';
import { toast } from 'sonner';
import { CheckCircle, Eye, Trash2 } from 'lucide-react';
import { DocumentUploadButton } from '../employees/DocumentUploadButton';
import { ApprovedDeleteButton } from './ApprovedDeleteButton';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Dosya yoksa "Belge Yüklenmedi", yüklenip incelenmediyse "Onay Bekliyor"
export const firmDocStatus = (status, hasFile) => {
  if (status === 'onay') return { label: 'Onaylı', cls: 'bg-emerald-100 text-emerald-700' };
  if (status === 'eksik') return { label: 'Eksik', cls: 'bg-rose-100 text-rose-700' };
  if (status === 'kapsam_disi') return { label: 'Kapsam Dışı', cls: 'bg-slate-100 text-slate-500' };
  return hasFile ? { label: 'Onay Bekliyor', cls: 'bg-amber-100 text-amber-700' } : { label: 'Belge Yüklenmedi', cls: 'bg-slate-100 text-slate-600' };
};

export const FirmDocStatusBadge = ({ status, hasFile, testId, hideEmpty, onClick, label }) => {
  if (hideEmpty && !hasFile && (!status || status === 'beklemede')) return null;
  const s = { ...firmDocStatus(status, hasFile), ...(label ? { label, cls: 'bg-slate-900 text-white' } : {}) };
  if (onClick) return (
    <button type="button" onClick={onClick} title="Eksiklik nedenini gör" className={`inline-block rounded px-2 py-0.5 text-xs font-medium underline decoration-dotted underline-offset-2 transition-[filter] hover:brightness-95 ${s.cls}`} data-testid={testId}>{s.label}</button>
  );
  return <span className={`inline-block rounded px-2 py-0.5 text-xs font-medium ${s.cls}`} data-testid={testId}>{s.label}</span>;
};

export const FirmDocFileActions = ({ entityType, entityId, docKey, docLabel, hasFile, status, onUploaded, onDeleted, onView, testPrefix, allowApprovedDelete, optional = false }) => {
  const pending = hasFile && status === 'beklemede';

  const remove = async () => {
    if (!(await confirmDialog({ title: 'Belge silinsin mi?', description: <>{docLabel} belgesi silinecek. Bu işlem geri alınamaz.<DependencyRuleNote docKey={docKey} /></>, confirmLabel: 'Evet, Sil' }))) return;
    try {
      const res = await axios.delete(`${API}/${entityType}/${entityId}/document-files/${docKey}`);
      onDeleted(res.data);
      toast.success('Belge silindi');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Belge silinemedi');
    }
  };

  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {hasFile && (
        <span className="inline-flex items-center gap-1 text-xs font-medium text-emerald-700" data-testid={`${testPrefix}-uploaded`}>
          <CheckCircle className="h-3.5 w-3.5" />Belge yüklendi
        </span>
      )}
      {hasFile && (
        <button type="button" onClick={onView} className="inline-flex items-center gap-1 px-2 py-1 text-xs rounded border border-slate-200 text-slate-700 hover:bg-slate-50" data-testid={`${testPrefix}-view`}>
          <Eye className="h-3.5 w-3.5" />Görüntüle
        </button>
      )}
      {allowApprovedDelete && hasFile && status === 'onay' && (
        <ApprovedDeleteButton {...{ entityType, entityId, docKey, docLabel, onDeleted, testPrefix }} />
      )}
      {(pending || (hasFile && ['eksik', 'suresi_doldu'].includes(status))) && (
        <button type="button" title="Belgeyi sil" onClick={remove} className="h-7 w-7 inline-flex items-center justify-center rounded border border-rose-200 text-rose-600 hover:bg-rose-50" data-testid={`${testPrefix}-delete`}>
          <Trash2 className="h-3.5 w-3.5" />
        </button>
      )}
      {pending || (status === 'onay' && hasFile) ? null : (
        <div className="w-28">
          <DocumentUploadButton entityType={entityType} entityId={entityId} docKey={docKey} hasFile={hasFile} optional={optional} label={hasFile ? 'Yeni sürüm' : 'Belge Yükle'} onUploaded={onUploaded} />
        </div>
      )}
    </div>
  );
};
